import { render, staticRenderFns } from "./DeliverableStatusOverview.vue?vue&type=template&id=09f48daa&"
import script from "./DeliverableStatusOverview.vue?vue&type=script&lang=js&"
export * from "./DeliverableStatusOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports